"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _immutable = _interopRequireDefault(require("immutable"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaLeft = _interopRequireDefault(require("UIComponents/layout/UIMediaLeft"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _FileDragAndDrop = _interopRequireDefault(require("FileManagerCore/components/FileDragAndDrop"));

var _Constants = require("../../Constants");

var StyledFolderRow = _styledComponents.default.a.withConfig({
  displayName: "FolderRowTile__StyledFolderRow",
  componentId: "sc-1m01de2-0"
})(["display:flex;align-items:center;height:100%;border:1px solid ", ";border-bottom:", ";", " &:hover{text-decoration:none;}"], _colors.KOALA, function (props) {
  return props.isLast ? "1px solid " + _colors.KOALA : 'none';
}, function (props) {
  return props.isOver && !props.disableUpload && "\n    border: 2px solid " + _colors.CALYPSO + ";\n    background-color: " + _colors.CALYPSO_LIGHT + ";\n ";
});

var StyledMedia = (0, _styledComponents.default)(_UIMedia.default).withConfig({
  displayName: "FolderRowTile__StyledMedia",
  componentId: "sc-1m01de2-1"
})(["width:100%;"]);

var FolderRowTile = function FolderRowTile(_ref) {
  var folder = _ref.folder,
      isLast = _ref.isLast,
      disableUpload = _ref.disableUpload,
      onDropFiles = _ref.onDropFiles,
      onSelect = _ref.onSelect;
  var handleDropFiles = (0, _react.useCallback)(function (files) {
    onDropFiles(files, folder);
  }, [folder, onDropFiles]);
  return _react.default.createElement(_FileDragAndDrop.default, {
    disabled: disableUpload,
    onDropFiles: handleDropFiles
  }, function (_ref2) {
    var isOver = _ref2.isOver,
        props = (0, _objectWithoutProperties2.default)(_ref2, ["isOver"]);
    return _react.default.createElement(StyledFolderRow, Object.assign({}, props, {
      className: _Constants.PICKER_FOLDER_CLASSNAME,
      isLast: isLast,
      isOver: isOver,
      disableUpload: disableUpload,
      onClick: function onClick() {
        return onSelect(folder);
      },
      "data-test-id": "browse-folder-row",
      "data-test-object-id": folder.get('id')
    }), _react.default.createElement(StyledMedia, {
      className: "p-x-2",
      align: "center"
    }, _react.default.createElement(_UIMediaLeft.default, {
      className: "align-center justify-center text-center",
      style: {
        width: _Constants.FILE_FOLDER_THUMB_SIZE
      }
    }, _react.default.createElement(_UIIcon.default, {
      name: "folder",
      color: _colors.CALYPSO,
      size: 20,
      className: "m-x-auto"
    })), _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_UITruncateString.default, null, folder.get('name')))));
  });
};

FolderRowTile.propTypes = {
  folder: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  isLast: _propTypes.default.bool.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  onDropFiles: _propTypes.default.func.isRequired,
  onSelect: _propTypes.default.func.isRequired
};
FolderRowTile.defaultProps = {
  disableUpload: false
};
var _default = FolderRowTile;
exports.default = _default;
module.exports = exports.default;